<template>
  <div class="promoCode">
    <dropdown ref="dropdown"
              @close="cancel"
              @open="focusInput"
    >
      <div slot="link"
           class="inputText --tag --sm --caret"
      >
        <div
            class="inputText__group"
        >
          <!-- <label class="inputTag__label" for="basic-url" v-if='!newPromoCode'>{{ $t('promo_code') }}</label> -->
          <input
              readonly
              @click="openModal()"
              @keydown.enter="$refs.dropdown.toggleDropdown()"
              class="inputText__input"
              type="text"
              :value="newPromoCode ? newPromoCode.toUpperCase() : $t('promo_code')"
              aria-label="Promo Code"
              aria-describedby="Promo Code"
              tabindex="0"
              name="Promo Code"
          >
          <!-- <p class="newPromoCode">{{ newPromoCode }}</p> -->
        </div>
      </div>
      <div slot="content"
           class="promoCode__modal"
      >
        <div class="promoCode__modalContainer surface">
          <form @keydown.enter="addPromoCode"
                @keydown.esc="cancel"
          >
            <div
                v-if="bookingData.promo.enable"
                class="inputText --sm"
            >
              <label class="inputText__label" for="promo_code">{{$t('promo_code')}}</label>
              <div class="inputText__group">
                <div class="inputText__icon">
                  <i class="fas fa-tag"></i>
                </div>
                <input
                    autocomplete="off"
                    ref="promoCode"
                    class="inputText__input"
                    id="promo_code"
                    name="promo_code"
                    aria-label="Promo Code"
                    aria-describedby="Promo Code"
                    tabindex="4"
                    autofocus
                    :maxlength="promoCodeMaxLength"
                    v-model="newPromoCode"
                >
              </div>
              <span class="inputText__feedback" v-if="promoCodeInvalid">
              {{ $t('promo_code_invalid') }}
            </span>
            </div>
          </form>
          <div class="promoCode__modalBtns">
            <button
                type="button"
                @click="cancel()"
                class="btn --sm"
                tab-index="11"
                id="cancel_pc"
                ref="cancelButton"
            >{{ $t('cancel') }}</button>
            <button
              @click="addPromoCode"
              type="button"
              class="btn --sm btn-primary"
            >
              {{ $t('continue') }}
            </button>
          </div>
        </div>
      </div>
    </dropdown>
  </div>
</template>

<script>
  import Dropdown from '../Dropdown'

  export default {
    components: {
      Dropdown
    },
    name: 'promoCode',
    data () {
      return {
        newPromoCode: '',
        promoCodeInvalid: false,
        promoCodeMaxLength: 15
      }
    },
    mounted () {
      this.newPromoCode = this.value
    },
    watch: {
      newPromoCode: {
        handler (v) {
          this.newPromoCode = v.toUpperCase()
        }
      }
    },
    methods: {
      addPromoCode: function () {
        if (this.validateCodeInserted()) {
          this.close()
          this.$emit('addPromoCode', this.newPromoCode.trim().toUpperCase())
        } else {
          this.promoCodeInvalid = true
          this.focusInput()
        }
      },
      validateCodeInserted: function () {
        let promoCodeLen = this.newPromoCode.length
        return promoCodeLen >= 0 && promoCodeLen <= this.promoCodeMaxLength
      },
      cancel: function () {
        this.newPromoCode = this.value
        this.close()
      },
      close: function () {
        this.$store.dispatch('notifyOverflowToParent', false)
        this.$refs.dropdown.show = false
      },
      openModal: function () {
        this.$store.dispatch('notifyOverflowToParent', true)
        this.promoCodeInvalid = false
      },
      focusInput: function () {
        this.$nextTick(() => {
          this.$refs.promoCode.focus()
        })
      }
    },
    props: {
      bookingData: { required: true, type: Object },
      value: { required: false, type: String, default: ''}
    }
  }
</script>

<style lang="sass">
.promoCode
  position: relative
  &__modal
    position: fixed
    width: 100%
    height: 100%
    top: 0
    left: 0
    display: flex
    align-items: center
    justify-content: center
    background-color: var(--color-overlay-80)
    z-index: 1000
    padding: 2rem
    &Container
      width: 100%
      max-width: 350px
      z-index: 1000
      padding: .75rem 1rem 1rem
    &Btns
      display: flex
      align-items: center
      justify-content: flex-end
      .btn:first-child
        margin-right: 1rem
@media (min-width: 992px)
  .promoCode
    &__modal
      position: absolute
      background-color: transparent
      width: 255px
      &Container
        position: absolute
        top: -3rem
        left: 0
        right: 0
        margin: auto
      &Btns
      .btn
        width: calc(50% - .25rem)
</style>
